import { del, get, post, put } from "../../services/ApiRouting";

// Function to fetch all
export async function getAllSectors(page = 1) {
  try {
    const response = await get(`${API_URL}/crud/sectors?page=${page}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching all :", error);
    throw error.response ? error.response.data : new Error("Network Error");
  }
}

// Function to create a new pay
export async function createSector(payData) {
  try {
    const formData = new FormData();
    formData.append("title", payData.title);
    formData.append("description", payData.description);

    const response = await post(`${API_URL}/crud/sectors`, formData);
    return response;
  } catch (error) {
    console.error("Error creating sector:", error);
    throw error.response ? error.response.data : new Error("Network Error");
  }
}

// Function to fetch a single pay by ID
export async function getSectorById(token, payId) {
  try {
    const response = await axios.get(`${API_URL}/crud/sectors/${payId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching pay with ID ${payId}:`, error);
    throw error.response ? error.response.data : new Error("Network Error");
  }
}

// Function to update an existing pay
export async function updateSector(payId, payData) {
  try {
    const formData = new FormData();
    formData.append("title", payData.title);
    formData.append("description", payData.description);

    const response = await put(`${API_URL}/crud/sectors/${payId}`, formData);
    return response;
  } catch (error) {
    console.error(`Error updating pay with ID ${payId}:`, error);
    throw error.response ? error.response.data : new Error("Network Error");
  }
}

// Function to delete a pay
export const deleteSector = async (id) => {
  try {
    const response = await del(`${API_URL}/crud/sectors/${id}`);
    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to delete pay");
  }
};
